import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import { useContext } from "react";
import { AppContext } from "../Theme";
import Checkout from "../components/checkout/Checkout";

export default function Checkoutpage() {
	const { darkmode, toggleMode } = useContext(AppContext);
	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar username="Nexcare" mode={darkmode} />
			</div>
			<Checkout mode={darkmode} />
		</>
	);
}
